import AddQuestionnaireToWorkspaceController from '../modals/add_questionnaire_to_workspace_controller';
import WorkspaceQuestionnairePurchaseController from '../modals/workspace_questionnaire_purchase';
import extractQuestionnaireData from '../../data_management/extractQuestionnaireData';
import { priceFormatter } from '@mojility/core-es6';

class QuestionnairesInWorkspace {

  constructor($scope, $location, featureToggles, localize, dataService, initialDataInteractor, workspaceInteractor,
              ModalService) {
    this.$scope = $scope;
    this.$location = $location;
    this.featureToggles = featureToggles;
    this.localize = localize;
    this.dataService = dataService;
    this.initialDataInteractor = initialDataInteractor;
    this.workspaceInteractor = workspaceInteractor;
    this.ModalService = ModalService;
  }

  $onChanges() {
    if (this.workspace !== undefined) this.loadQuestionnaires();
  }

  goToQuestionnaire(questionnaire) {
    if (this.isWorkspaceOwner()) this.$location.path('questionnaires/' + questionnaire.id);
  }

  isWorkspaceOwner() {
    return this.workspace && this.workspaceInteractor.isWorkspaceOwner(this.workspace);
  }

  addQuestionnaire() {
    return this.initialDataInteractor.ensureInitializedSession().then(() => {
      return new Promise(resolve => {
        this.showAddQuestionnaireModal(this.getUnavailableQuestionnaires())
          .then(modal => modal.close.then(() => {
            this.loadQuestionnaires();
            resolve();
          }));
      });
    })
  }

  getUnavailableQuestionnaires() {
    let availableQuestionnaireIds = this.questionnaires.map(i => i.id);
    return extractQuestionnaireData(this.initialDataInteractor).filter(q => {
      return !availableQuestionnaireIds.includes(q.id);
    });
  }

  showAddQuestionnaireModal(selectableQuestionnaires) {
    return this.ModalService.showModal({
      templateUrl: 'modals/add_questionnaire_to_workspace.html',
      controllerAs: '$ctrl',
      controller: AddQuestionnaireToWorkspaceController,
      inputs: {
        questionnaires: selectableQuestionnaires,
        workspaceInteractor: this.workspaceInteractor,
        workspaceId: this.workspace.id,
        localize: this.localize
      }
    });
  }

  loadQuestionnaires() {
    this.workspaceInteractor.getQuestionnaires(this.workspace.id).then(list => {
      this.questionnaires = list;
      this.$scope.$digest();
    });
  }

  removeQuestionnaire(questionnaire) {
    return this.workspaceInteractor.removeQuestionnaire(this.workspace.id, questionnaire.id)
      .then(() => {
        this.questionnaires.splice(this.questionnaires.indexOf(questionnaire), 1);
        this.$scope.$digest();
      });
  }

  canPurchase() {
    return this.featureToggles.isAvailable('purchase_in_workspace') && !this.isWorkspaceOwner();
  }

  purchaseQuestionnaire(questionnaire) {
    return this.ModalService.showModal({
      templateUrl: 'modals/workspace_questionnaire_purchase.html',
      controllerAs: '$ctrl',
      controller: WorkspaceQuestionnairePurchaseController,
      inputs: {
        questionnaire: questionnaire,
        workspace: this.workspace,
        workspaceInteractor: this.workspaceInteractor
      }
    })
  }

  get canGoToQuestionnaire() {
    return this.isWorkspaceOwner();
  }

  formattedPrice(questionnaire) {
    if (questionnaire.price == 0.0) {
      return "Free"
    } else {
      return priceFormatter(questionnaire.price);
    }
  }

}

export default {
  name: 'questionnairesInWorkspace',
  obj: {
    controller: QuestionnairesInWorkspace,
    bindings: {
      workspace: '<'
    },
    template: `
      <header class="component">
          <h2>{{ $ctrl.localize.string('questionnaires_in_workspace', 'title') }}</h2>
          
          <ol>
            <li ng-if="$ctrl.isWorkspaceOwner()">
                <action-button initial-text="$ctrl.localize.string('add')"
                               icon="ic_visibility"
                               type="borderless"
                               risk="safe"
                               action="$ctrl.addQuestionnaire()"></action-button>
            </li>
          </ol>
      </header>
      
      <ol class="list">
          <li ng-repeat="questionnaire in $ctrl.questionnaires">
              <h3 ng-click="$ctrl.goToQuestionnaire(questionnaire)"
                  ng-class="$ctrl.canGoToQuestionnaire ? 'clickable' : ''">{{questionnaire.title}}</h3>
              <ol class="metadata">
                  <li>{{ $ctrl.formattedPrice(questionnaire) }}</li>
              </ol>
              <section class="details">{{ questionnaire.short_description }}</section>
              <ol class="actions">
                  <li ng-if="$ctrl.isWorkspaceOwner()">
                      <action-button initial-text="$ctrl.localize.string('hide')"
                                     icon="ic_visibility_off"
                                     type="borderless"
                                     risk="info"
                                     action="$ctrl.removeQuestionnaire(questionnaire)"></action-button>
                  </li>
                  <li ng-if="$ctrl.canPurchase()">
                      <action-button initial-text="$ctrl.localize.string('purchase')"
                                     icon="ic_play_circle_outline"
                                     type="borderless"
                                     risk="safe"
                                     action="$ctrl.purchaseQuestionnaire(questionnaire)"></action-button>
                  </li>
              </ol>
          </li>
      </ol>
    `
  }
}